import * as React from 'react';
import { useCallback } from 'react';

import { useSlate, useSlateStatic } from 'slate-react';

import { IndentLessIcon } from '@coursera/cds-icons';

import Button, { TOOLBAR_BUTTON_TYPES } from 'bundles/cml/editor/components/buttons/Button';
import { canDecreaseIndent, decreaseIndent } from 'bundles/cml/editor/components/buttons/indent/listIndentUtils';

import _t from 'i18n!nls/cml';

const DecreaseIndentButton = () => {
  const editor = useSlate();
  const staticEditor = useSlateStatic();
  const disabled = !canDecreaseIndent(editor);

  const handleClick = useCallback<(...args: $TSFixMe[]) => $TSFixMe>(
    () => decreaseIndent(staticEditor),
    [staticEditor]
  );

  const shortcutKey = `(shift+tab)`;
  return (
    <Button
      onClick={handleClick}
      disabled={disabled}
      active={false}
      className="rc-DecreaseIndentButton"
      title={_t('Decrease Indent #{shortcutKey}', { shortcutKey })}
      type={TOOLBAR_BUTTON_TYPES.formatting}
    >
      <IndentLessIcon size="small" />
    </Button>
  );
};

export default DecreaseIndentButton;
